import {css} from 'styled-components';
import { AntCollapseV5Styled } from './antdV5/antCollapse.style';
import { AntInputV5Styled } from './antdV5/antInput.style';
import { AntStatisticV5Styled } from './antdV5/antStatistic.style';
import { getCurrentBrowserType } from '../components/PdfViewer/helper';

// To deal inreased specificity of antdV5 styles,
// we cannot use antd classNames in places where it is not intended to be used at:
// eg: using "ant-modal-close" in Notification Popover (which is not a modal)
// hence - we need to use styled-components to allow antd classNames

// Also deals with breaking changes due to missing styles after antdV5 upgrade
// These styles are copied from dev console - Elements

const {
    isFirefox,
} = getCurrentBrowserType();
const formItemLabelMinHeight = isFirefox ? "24.5px" : "23px";

export const AntdV5Styled = css`


  .ant-modal-close {
    position: absolute;
    top: 17px;
    z-index: 1010;
    width: 22px;
    height: 22px;
    padding: 0;
    font-weight: 600;
    line-height: 1;
    color: rgba(0, 0, 0, 45%);
    text-decoration: none;
    cursor: pointer;
    background: transparent;
    border: 0;
    border-radius: 4px;
    outline: 0;
    transition: color 0.2s, background-color 0.2s;
    inset-inline-end: 17px;

    &:hover {
      color:rgba(0, 0, 0, 88%);
      text-decoration:none;
      background-color:rgba(0, 0, 0, 6%);
    }

    &:active { 
      background-color:rgba(0, 0, 0, 15%);
    }

    &:focus-visible {
      outline:4px solid #91caff;
      outline-offset:1px;
      transition: outline-offset 0s, outline 0s;
    }
  }

  .ant-modal-close-x {
    display: block;
    font-size: 16px;
    font-style: normal;
    line-height: 22px;
    text-align: center;
    text-transform: none;
    text-rendering: auto;
  }


  ${AntCollapseV5Styled}
  /* ${AntInputV5Styled} */
  ${AntStatisticV5Styled}

  /* For ListMenu with href/link button */
  .ant-btn>a:only-child:after {
    position: absolute;
    inset: 0;
    content: "";
    background: transparent;
  }

  /* to prevent text to enlarge (eg. in ContactSelect, in tags with tooltip) */
  .ant-tooltip-open {
            /* 27/8: having font-size: unset will now trigger the text enlarge on hover, so commented it out */
    /* font-size: unset; */

    /* text-size-adjust: none; */
  }

  /* to fix in safari tabs text will overflow (eg in Company Settings) */
  .ant-tabs >.ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs >div>.ant-tabs-nav .ant-tabs-nav-wrap {
    transform: unset;
  }

  .ant-tag {
    .anticon {
      &.ant-tooltip-open {
        /* 27/8: having font-size: unset will now trigger the text enlarge on hover, so commented it out */
        /* font-size: unset; */
      }
    }
  }

  .ant-tooltip {
    .ant-tag {
      background: #fafafa;
    }
  }

  .ant-form-item-label > label {
    box-sizing: content-box;
    min-height: ${formItemLabelMinHeight}; /* To standardise the height of labels with/without asterisk */
  }

  /* To fix antd DatePicker.RangePicker dropdown overflow out of page, preventing users from navigating the dates.
  Ref: https://stackoverflow.com/questions/60091618/react-daterangepicker-mobile-friendly 
  */
  @media only screen and (width < 992px) { 
    .ant-picker-panels { 
        flex-direction: column;
        overflow-y: scroll;
        height: 400px;
    } 
  }
`;
